import { Head, usePage } from "@inertiajs/react";
import { GlobalStyle } from "../../constants/global-style";
import ProvideLoggedInUser from "../../providers/ProvideLoggedInUser";
import VideoPembelajaranIndexApp from "../../video_pembelajaran/index/VideoPembelajaranIndexApp";

// Auto-resolved page for VideoPembelajaranController#index when the
// `video_pembelajaran_rebrand_v1` FeatureToggle is ON
// (InertiaRenderable#inertia_component_name -> "video_pembelajaran/Index").
//
// Props (from the controller):
//   theme: 'dark' | 'light' — driven by dark_mode_v1. Default 'light'.
//   learning_name_options: [{ slug, name, count }] — Nama Materi Belajar rows
//        that have at least one listable video. Drives the sidebar picker.
//   category_options: [{ slug, name, count }] — distinct `category_name` values
//        in use (that column is still free text, not a vocabulary).
//
// The video list itself is fetched client-side from /api/v1/video_pembelajaran,
// mirroring how the homepage carousels self-fetch.
export default function Index() {
  const {
    theme = "light",
    learning_name_options: learningNameOptions = [],
    category_options: categoryOptions = [],
  } = usePage().props;

  return (
    <>
      <Head>
        <title>Semua Video Pembelajaran — Taxsam Learning Center</title>
        <meta
          name="description"
          content="Katalog lengkap video pembelajaran pajak Taxsam Learning Center, dikelompokkan per Nama Materi Belajar Pajak. Cari dan filter materi yang kamu butuhkan."
        />
      </Head>
      <GlobalStyle />
      <ProvideLoggedInUser>
        <VideoPembelajaranIndexApp
          theme={theme}
          learningNameOptions={learningNameOptions}
          categoryOptions={categoryOptions}
        />
      </ProvideLoggedInUser>
    </>
  );
}
